import { createApi, fetchBaseQuery } from "@reduxjs/toolkit/query/react";
import {
  approveOrDeclineStatus,
  archiveTasks,
  getTasks,
  saveTask,
} from "app/services/task/taskService";
import { BASE_URL } from "static/constants";

export const tasksApi = createApi({
  reducerPath: "tasksApi",
  baseQuery: fetchBaseQuery({ baseUrl: BASE_URL }),
  tagTypes: ["tasks"],
  endpoints: ({ query, mutation }) => ({
    getTasks: query({
      queryFn: ({ selectedTab, query }) => {
        return { data: getTasks(selectedTab, query) };
      },
      providesTags: ["tasks"],
    }),

    saveTask: mutation({
      queryFn: ({
        requestType,
        taskId,
        description,
        status,
        account,
        notes,
        patientId,
        patientName,
        patientSerialNumber,
      }) => {
        return {
          data: saveTask({
            requestType,
            taskId,
            description,
            status,
            account,
            notes,
            patientId,
            patientName,
            patientSerialNumber,
          }),
        };
      },
      invalidatesTags: ["tasks"],
    }),
    archiveTasks: mutation({
      queryFn: (taskIds) => {
        return {
          data: archiveTasks(taskIds),
        };
      },
      invalidatesTags: ["tasks"],
    }),
    approveOrDeclineStatus: mutation({
      queryFn: ({ requestId, status }) => {
        return {
          data: approveOrDeclineStatus(requestId, status),
        };
      },
      invalidatesTags: ["tasks"],
    }),
  }),
});

export const {
  useGetTasksQuery,
  useSaveTaskMutation,
  useArchiveTasksMutation,
  useApproveOrDeclineStatusMutation,
} = tasksApi;
